// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__feoDP","Icon":"Card_Icon__T7xiL","Title":"Card_Title__uxJFH","Subtitle":"Card_Subtitle__ptBti"};